﻿import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cIf from 'classnames';
import { CartControlContextInstance } from '../src/logic/reactcontext/cart-control-context';
import { SiteCustomizationClass, SiteCustomizationContext } from '../src/logic/reactcontext/site-customization-context';

//Uses window.tsapp
var ctl = tsapp.ctl;
var user = tsapp.user;
var accounting = require('accounting');
var tr = require('ts-translate-js').default.boundTR;
var trN = tr;
var redirect = ctl.utilctl.redirect;
var tsRest = require('ts-rest-client');
var SaleQuestionnaireFilloutManager = require('ts-common-react-controls').SaleQuestionnaireFilloutManager;
var SaleQuestionnaireProvider = ctl.salequestionnaireprovider;

export class CartWidget extends Component {
    constructor(props) {
        super(props);

        this.state = {
            cart:null,
            showAutoSaleQuestionnaire: false,
            saleQuestionnaires: null
        };

        this.handleContinueShopping = this.handleContinueShopping.bind(this);
        this.handleCheckout = this.handleCheckout.bind(this);
        this.handleRefreshSaleQuestionnaire = this.handleRefreshSaleQuestionnaire.bind(this);
        this.raiseContentChanged = this.raiseContentChanged.bind(this);
        this.handleUpdateCart = this.handleUpdateCart.bind(this);
    }

    componentDidMount(){
        //RCOMBRIDGE_copyTrackingCookies();
        this.siteSettingsContext = new SiteCustomizationClass(tsapp.siteSettings);
        this.loadCart()
        this.raiseContentChanged();
    }

    componentDidUpdate(){
        this.raiseContentChanged();
    }

    componentWillUnmount() {
        this.cartRequest.abort();
    }

    raiseContentChanged() {
        // Set timeout because even though React rendered the tags, they are not yet drawn on the screen.
        setTimeout(function(){
            if(this.props.onContentChange !== undefined) this.props.onContentChange();
        }.bind(this), 0);
    }

    handleContinueShopping(){
        tsapp.goToHome(this.props.integ);
    }

    handleCheckout(){
        tsapp.goToCheckout(this.props.integ);
    }

    loadCart(){
        this.cartRequest = tsapp.mvcapi.postCtl("cart/cart", null, { cache: false })
                                .success(function(data){
                                    this.setState({cart:data.Cart})
                                }.bind(this));
    }

    handleUpdateCart(){
        // If we reload the cart, we have a reason to do it, let's reload the small cart status as well
        if(typeof window.RefreshCartIFrame != 'undefined') window.RefreshCartIFrame(); // This is a global site function. We will have to do something for integrations that don't have a small cart!
        
        if(typeof window.RefreshCart !== 'undefined') window.RefreshCart();

        CartControlContextInstance.cartControl.refreshCart();

        this.loadCart()
    }

    handleRefreshSaleQuestionnaire() {
        this.handleUpdateCart();
        
        this.setState({ showAutoSaleQuestionnaire: false }); 
    }

    handleOpenAutoSaleQuestionnaire(saleQuestionnaires) {

        this.setState({ saleQuestionnaires: saleQuestionnaires, showAutoSaleQuestionnaire: true });
        
        this.raiseContentChanged();
    }
    
    render(){
        var cartwidget,
            cartContent,
            cartMessage,
            checkoutButton;

        if(this.state.showAutoSaleQuestionnaire) {
            cartwidget = <SaleQuestionnaireFilloutManager 
                                viewProvider={SaleQuestionnaireProvider.default}
                                showInPopup={false}
                                saleQuestionnaires={this.state.saleQuestionnaires}
                                onCancel={this.handleRefreshSaleQuestionnaire}
                                onSave={this.handleRefreshSaleQuestionnaire}
                                onContentChange={this.raiseContentChanged}>                    
            </SaleQuestionnaireFilloutManager>;
        } else {
            
            if (this.state.cart == null) {
                cartMessage = <p>{tr("cartwidget.pleasewait")}</p>;
            } else {
                if(this.state.cart.Items.length > 0){
                    checkoutButton = <button type="button" className="btn btn-primary" onClick={this.handleCheckout}>{tr("cartwidget.checkout")}</button>;
                    cartContent = <ctl.cart.CartContent integ={this.props.integ} cart={this.state.cart} onContentChange={this.props.raiseContentChanged} onUpdateCart={this.handleUpdateCart} onModifySaleQuestionnaire={this.handleOpenAutoSaleQuestionnaire} />;
                } else
                cartMessage = <p>{tr("cartwidget.yourcartisempty")}</p>;
            }
            
            cartwidget = (<div>
                <div className="page-header">
                    <h3>{tsapp.tr("cartwidget.title")}</h3>
                </div>

                {cartContent}
                {cartMessage}

                <div className="btn-toolbar pull-right">
                    <button type="button" className="btn btn-default" onClick={this.handleContinueShopping}>{tr("cartwidget.continueshopping")}</button>
                    {checkoutButton}
                </div>
            </div>);
        }

        return (
            <SiteCustomizationContext.Provider value={this.siteSettingsContext}>
                <div className={cIf("container-fluid", this.props.integ)}>
                    {cartwidget}
                </div>
            </SiteCustomizationContext.Provider>
        );
    }
};

CartWidget.propTypes = {
    integ: PropTypes.string.isRequired,
    onContentChange: PropTypes.func,
}
